export default {
  nome: {
    value: '',
    required: false,
    state: null
  },
  inactive: {
    value: false,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/nxSenhas/categoria/components/add/subcategoria-form.js